import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { configureStore } from '@reduxjs/toolkit';
import appReducer from './appState/stateReducer';
import './styles/themes.css';
import ThemeInitializer from './theme/ThemeInitializer';
import {
  ErrorProvider,
  GlobalDataProvider,
  GlobalActionProvider,
  SessionDataProvider,
  SessionActionProvider,
  UserActionProvider,
  UnsavedChangesProvider,
  GatewayProvider,
} from './providers';

const store = configureStore({
  reducer: appReducer,
});

export type AppState = ReturnType<typeof store.getState>;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorProvider>
        <GlobalDataProvider>
          <GlobalActionProvider>
            <SessionDataProvider>
              <SessionActionProvider>
                <UserActionProvider>
                  <GatewayProvider>
                    <UnsavedChangesProvider>
                      <ThemeInitializer />
                      <App />
                    </UnsavedChangesProvider>
                  </GatewayProvider>
                </UserActionProvider>
              </SessionActionProvider>
            </SessionDataProvider>
          </GlobalActionProvider>
        </GlobalDataProvider>
      </ErrorProvider>
    </Provider>
  </React.StrictMode>,
);
